export function getAgeInYearsAndMonths(dateString) {
  const birthDate = new Date(dateString);
  const today = new Date();
  
  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  const days = today.getDate() - birthDate.getDate();

  // Adjust if the current month is before the birth month, or it's the same month but the current day is before the birth day
  if (months < 0 || (months === 0 && days < 0)) {
    years--;
    months += 12;
  }

  // Adjust for days if the current day is before the birth day
  if (days < 0) {
    months--;
    if (months < 0) {
      months += 12;
      years--;
    }
  }

  return { years, months };
}